export default "/images/vendor/flag-icon-css/flags/1x1/re.svg?7e8577e98f035e765e59bb047a0cd2d2";